interface CrmPersonaBadgeProps {
  source: string;
}

export function CrmPersonaBadge({ source }: CrmPersonaBadgeProps) {
  const label = source === 'crm_deal' ? 'CRM Deal' : 'CRM';
  return (
    <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-blue-50 text-blue-700">
      {label}
    </span>
  );
}
